module.exports = __webpack_public_path__ + "img/gd4.28408b71.jpeg";